import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';

import { RequisitionsConfigActions } from '../config/config.store';
import { RequisitionsFlowsActions } from '../flows/flows.store';
import { RequisitionsFormActions } from '../form/form.store';

@Injectable({
  providedIn: 'root',
})
export class RequisitionsCommonEffects {
  public refresh$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequisitionsConfigActions.updateWithDepartmentsSuccess),
      switchMap(() => [
        RequisitionsFlowsActions.fetchCollection(),
        RequisitionsFormActions.fetch(),
      ]),
    ),
  );
  constructor(private actions$: Actions) {}
}
